var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "_about"
  }, [_vm._m(0), _c('div', {
    staticClass: "_about-right",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]), _c('hr')]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "_about-left"
  }, [_c('h1', [_vm._v("Узнайте больше "), _c('br'), _c('span', [_vm._v("о любимом сервисе")])]), _c('div', {
    staticClass: "_about-hide-mobile"
  }, [_c('hr'), _c('p', [_vm._v("Скоро в App Store и Google Play")]), _c('img', {
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "src": require("@/assets/img/appstore.svg"),
      "alt": "AppStore"
    }
  }), _c('img', {
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "src": require("@/assets/images/googleplay.png"),
      "alt": "GooglePlay"
    }
  })])]);
}]

export { render, staticRenderFns }